export default __webpack_public_path__ + "static/media/youGuessedWrong.da94771b.gif";